export default {"categories":"_5QJ2M","sportFilter":"VT9DK","pill":"uAgD-","active":"uNNAe"};